import { Component, OnInit, inject, forwardRef, computed, output } from '@angular/core';
import { forkJoin } from "rxjs";
import { CommonModule } from '@angular/common';
import { DrawerModule } from 'primeng/drawer';
import { CommandButtonComponent } from '../pcpcommandbar/commandbutton/commandbutton.component';
import { PcpCommandBarComponent } from '../pcpcommandbar/pcp-commandbar.component';
import { RouterModule } from '@angular/router';
import { AuthService, ModalService } from '../../services';
import { Claims, NoticeWithUnreadMessageDto } from '../../types';
import { Notice } from "../../types/notice";
import { PCPCommonModule } from "../../pcpcommon.module";
import { NoticeCenterService } from '../../services/data/noticecenter.service';
import { NoticeCardComponent } from '../notice-card/notice-card.component';
import * as _ from 'lodash';



@Component({
  selector: "app-notice-center",
  templateUrl: "./notice-center.component.html",
  styleUrls: ["./notice-center.component.scss"],
  standalone: true,
  imports: [CommonModule, DrawerModule, CommandButtonComponent, PcpCommandBarComponent, RouterModule, PCPCommonModule, NoticeCardComponent]
})
export class NoticeCenterComponent implements OnInit {

  readonly closeSidebar = output<void>();
  readonly noticeChanged = output<boolean>();
  hasNotices = false;
  showSideBar = false;

  userId: string;
  overdueConstructionUpdates: Notice[] = [];
  messages: Notice[] = [];

  private authService: AuthService = inject(forwardRef(() => AuthService));
  private noticeCenterService: NoticeCenterService = inject(NoticeCenterService);
  private modalService: ModalService = inject(ModalService);

  public sortedNotices = computed(() => _.orderBy(this.noticeCenterService.allNotice(), ['startDate'], ['desc']))


  constructor() {
    
  }


  ngOnInit() {
    this.userId = this.authService.getClaimValue<string>(Claims.azureGUID); 
    
      this.noticeCenterService.getAllActiveNotices().subscribe(notices => {
        this.noticeCenterService.updateActiveNotices(notices);
      });
  }

  toggleVisibility(visible: boolean) {
    if (visible) {
      this.openPanel();
    }
    else {
      this.oncloseSidebar();
    }
  }

  openPanel() {
    this.showSideBar = true;
  } 

  oncloseSidebar() {
    this.showSideBar = false;
    // TODO: The 'emit' function requires a mandatory void argument
  this.closeSidebar.emit(null);
  }

  onDismissNotice(noticeId: number) {
    this.noticeCenterService.markNoticeAsRead(noticeId).subscribe({
      next: () => {       
          this.noticeCenterService.removeNotice(noticeId);       
      },      
      error: (err) => {
        this.handleError(err);
      }
    });
  }

  handleError(err: ErrorEvent): void {
    this.modalService.showModal({ content: err.error.Message ? err.error.Message : err.error, type: "error", autodismiss: false });
  }
  
}
